export enum TourAvailabilityStatusType {
  AVAILABLE = 'Available',
  PERSON_QUOTA_NOT_AVAILABLE = 'PersonQuotaNotAvailable',
  ROOM_QUOTA_NOT_AVAILABLE = 'RoomQuotaNotAvailable',
  PACKAGE_NOT_AVAILABLE = 'PackageNotAvailable',
}
